import {newSpecPage} from '@stencil/core/testing';
import {Stepper} from '../stepper';
import {Step} from '../../JoyStep/step';

it('should properly render stepper with sub-steps and a too high step number', async () => {
    const page = await newSpecPage({
        components: [Stepper, Step],
        html: `
            <joy-stepper step="2" sub-step="666">
                <joy-step>First Step</joy-step>
                <joy-step sub-steps="3">Second Step</joy-step>
                <joy-step>Third Step</joy-step>
            </joy-stepper>
        `,
    });

    const currentItem = Array.from(page.body.querySelectorAll('joy-step'))[1];
    expect(currentItem.currentSubStep).toBe(3);
});
